import { render } from "./ShoppingListPage.vue?vue&type=template&id=9848e3fc&scoped=true&ts=true"
import script from "./ShoppingListPage.vue?vue&type=script&lang=ts"
export * from "./ShoppingListPage.vue?vue&type=script&lang=ts"

import "./ShoppingListPage.vue?vue&type=style&index=0&id=9848e3fc&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9848e3fc"]])

export default __exports__